import React from 'react';
import { db, auth } from '../settings/firebase';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import IconButton from "@material-ui/core/IconButton";
import MultiLineText from './MultilineText';

// コメントの表示
class CommentItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {message: props.message, name: "", avatar: "", namelink: "/", uid: "", mylike: false};
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  async componentDidMount() {
    if(this.state.message.uid !== "") {
      // console.log(this.state.message.uid);
      await db.collection("users").doc(this.state.message.uid).get().then((doc) => {
        this.setState({name: doc.data().name, avatar: doc.data().avatarUrl, namelink: "/" + doc.data().displayid});
      });
    }
    await auth.onAuthStateChanged(user => {
      if (user) {
        let likes = this.state.message.like;
        let mylike = false;
        // console.log(likes)
        likes.forEach(like => {
          if (like.uid === user.uid) {
            mylike = true;
          }
        })
        this.setState({uid: user.uid, mylike: mylike})
      }
    })
  }

  componentWillUnmount = () => {
  }

  changeLikeMessage = () => {
    if(this.state.uid !== ""){
      let msg = this.state.message;
      let likes = this.state.message.like;
      let mylike = true;
      let idx = 0;
      likes.forEach(like => {
        if (like.uid === this.state.uid) {
          mylike = false;
          likes.splice(idx, 1);
        }
        idx += 1;
      })
      if (mylike) {
        likes.push({
          uid: this.state.uid,
          ts: new Date(),
        })
      }
      msg.like = likes;
      let msgs = this.props.data;
      msgs.splice(this.props.index, 1, msg);
      db.collection("items").doc(this.props.pid).update({
        messages: msgs,
      })
      this.setState({mylike: mylike})
    }
  }
  
  render() {
    const message = this.state.message;
    const name = this.state.name;
    const avatar = this.state.avatar;
    let datetime = new Date(message.ts.seconds * 1000);
    if(!message.ts.seconds) {
      datetime = message.ts;
    }
    // console.log(message)
    return (
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alt={name} src={avatar} />
        </ListItemAvatar>
        <ListItemText
          primary={<Link style={{color: "#333333"}} href={this.state.namelink}>{name}</Link>}
          secondary={
            <React.Fragment>
              <Typography
                  component="span"
                  variant="body2"
                  color="textPrimary"
              >
                <MultiLineText>{message.text}</MultiLineText>
              </Typography>
              <br />
              <Typography
                component="span"
                variant="caption"
                color="textSecondary"
              >
                {datetime.toLocaleString('ja')}
              </Typography>
            </React.Fragment>
          }
        />
        <div style={{display: "flex", alignItems: "center"}}>
          <IconButton aria-label="like" onClick={this.changeLikeMessage} >
            {this.state.mylike? <FavoriteIcon style={{color: "#ff116b"}}/> 
            : <FavoriteBorderOutlinedIcon /> }
          </IconButton>
          <Typography>{this.props.message.like.length}</Typography>
        </div>
      </ListItem>
    )
  }
}


export default class ViewComments extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props.data)
    this.state = {data: props.data};
  }
  
  render() {
    const data = this.state.data;
    // console.log(data)
    let ary = [];
    for(let key_idx = 0; key_idx < data.length; key_idx++){
      ary.unshift(<Divider key={'divider' + key_idx} variant="inset" />)
      ary.unshift(<CommentItem key={'comment' + key_idx} message={data[key_idx]} data={data} index={key_idx} pid={this.props.pid} />)
    }
    return (
      <>
        {ary}
      </>
    )
  }
}